import { render, staticRenderFns } from "./ResumeDeliveries.vue?vue&type=template&id=5a63cb4e&scoped=true&"
import script from "./ResumeDeliveries.vue?vue&type=script&lang=js&"
export * from "./ResumeDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./ResumeDeliveries.vue?vue&type=style&index=0&id=5a63cb4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63cb4e",
  null
  
)

export default component.exports